document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  // ── 데이터 로드 ──────────────────────────────────────────────
  const productsStep1 = JSON.parse(document.getElementById('byl-products-step1').textContent);
  const productsStep2 = JSON.parse(document.getElementById('byl-products-step2').textContent);

  const allProducts = { 1: productsStep1, 2: productsStep2 };

  // ── 번들 할인율 (스키마 설정값, 퍼센트 정수) ──────────────────
  const bundleDiscountPercent = parseFloat(document.querySelector('.byl-wrap')?.dataset.bundleDiscount || '0') || 0;

  // ── State ────────────────────────────────────────────────────
  const state = {
    1: { productIndex: 0, product: null, variantId: null, size: '', selectedOptions: [] },
    2: { productIndex: 0, product: null, variantId: null, size: '', selectedOptions: [] },
    activeTab: 1,
  };

  // ── Swiper 초기화 ────────────────────────────────────────────
  const swiperTop = new Swiper('.byl-swiper-top', {
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    on: {
      slideChange: function () {
        const index = this.activeIndex;
        selectProduct(1, index);
        updateNavDeactive(1, index, document.querySelector('.byl-left'));
      },
    },
  });

  const swiperBottom = new Swiper('.byl-swiper-bottom', {
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    on: {
      slideChange: function () {
        const index = this.activeIndex;
        selectProduct(2, index);
        updateNavDeactive(2, index, document.querySelector('.byl-left'));
      },
    },
  });

  let swiperDetail = null;

  function initDetailSwiper(images) {
    if (swiperDetail) swiperDetail.destroy(true, true);

    const wrapper = document.getElementById('byl-detail-slides');
    wrapper.innerHTML = images
      .filter(Boolean)
      .map((src) => `<div class="swiper-slide"><img src="${src}" loading="lazy"></div>`)
      .join('');

    swiperDetail = new Swiper('.byl-swiper-detail', {
      slidesPerView: 2.5,
      spaceBetween: 4,
      //pagination: { el: '.byl-detail-pagination', clickable: true },
      observer: true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: 2.01,
        },
      },
    });
  }

  // ── 탭 전환 ──────────────────────────────────────────────────
  document.querySelectorAll('.byl-tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      const tabNum = parseInt(this.dataset.tab);
      switchTab(tabNum);
    });
  });

  function switchTab(tabNum) {
    state.activeTab = tabNum;

    document.querySelectorAll('.byl-tab').forEach((t) => {
      t.classList.toggle('is-active', parseInt(t.dataset.tab) === tabNum);
    });
    document.querySelectorAll('.byl-tab-panel').forEach((p) => {
      p.classList.toggle('is-active', parseInt(p.dataset.panel) === tabNum);
    });

    // 현재 탭의 선택된 상품 detail 업데이트
    if (state[tabNum].product) {
      updateProductDetail(state[tabNum].product);
    }
  }

  // ── 바닥컷 그리드 클릭 ───────────────────────────────────────
  document.querySelectorAll('.byl-grid-item').forEach((item) => {
    item.addEventListener('click', function () {
      const step = parseInt(this.dataset.step);
      const index = parseInt(this.dataset.index);
      selectProduct(step, index);
    });
  });

  function selectProduct(step, index) {
    const product = allProducts[step][index];
    if (!product) return;

    state[step].productIndex = index;
    state[step].product = product;
    state[step].variantId = null;
    state[step].size = '';

    state[step].selectedOptions = product.options ? new Array(product.options.length).fill(null) : [];

    // 그리드 아이템 활성화
    document.querySelectorAll(`.byl-grid-item[data-step="${step}"]`).forEach((el) => {
      el.classList.toggle('is-active', parseInt(el.dataset.index) === index);
    });

    // 활성 아이템으로 가로 스크롤 이동
    const activeItem = document.querySelector(`.byl-grid-item[data-step="${step}"][data-index="${index}"]`);
    const grid = activeItem?.closest('.byl-flat-lay-grid');
    if (activeItem && grid) {
      const itemLeft = activeItem.offsetLeft;
      const itemWidth = activeItem.offsetWidth;
      const gridWidth = grid.offsetWidth;
      grid.scrollTo({
        left: itemLeft - (gridWidth / 2) + (itemWidth / 2),
        behavior: 'smooth',
      });
    }

    // 왼쪽 썸네일 슬라이더 동기화
    const swiper = step === 1 ? swiperTop : swiperBottom;
    swiper.slideTo(index);

    document.querySelectorAll(`.byl-thumb-slide[data-step="${step}"]`).forEach((el) => {
      el.classList.toggle('is-active', parseInt(el.dataset.index) === index);
    });

    // ★ 모바일 썸네일 동기화
    if (window._mobileThumb) {
      const mobileSwiper = step === 1 ? window._mobileSwiperTop : window._mobileSwiperBottom;
      mobileSwiper.slideTo(index);

      window._mobileThumb.querySelectorAll(`.byl-thumb-slide[data-step="${step}"]`).forEach((el) => {
        el.classList.toggle('is-active', parseInt(el.dataset.index) === index);
      });
    }

    // 사이즈 옵션 렌더링
    renderSizeOptions(step, product);

    // 탭 전환
    switchTab(step);

    // 상품 detail 업데이트
    updateProductDetail(product);

    updateYourSet();
    updateATC();
  }

  // ── 사이즈 옵션 렌더링 ───────────────────────────────────────
  // ── 옵션 렌더링 (모든 옵션 순차 노출) ───────────────────────
  function renderSizeOptions(step, product) {
    const sizeArea = document.getElementById(`byl-size-${step}`);
    const sizeLabel = document.getElementById(`byl-size-label-${step}`);
    const sizeBtns = document.getElementById(`byl-size-btns-${step}`);

    const variants = product.variants;
    if (!variants || !variants.length) {
      sizeArea.style.display = 'none';
      return;
    }

    // 옵션 개수 파악 (option1~option3)
    const optionCount = variants[0].option3 ? 3 : variants[0].option2 ? 2 : 1;

    // 각 옵션별 고유값 추출
    const optionGroups = [];
    for (let i = 0; i < optionCount; i++) {
      const key = `option${i + 1}`;
      const values = [...new Set(variants.map((v) => v[key]).filter(Boolean))];
      // 옵션명은 variant 데이터에 없으므로 product JSON에서 가져옴
      // Liquid에서 option 이름도 JSON에 포함시켜야 함 (아래 Liquid 수정 참고)
      optionGroups.push({ key, values });
    }

    // 선택 상태 관리
    const selectedOptions = optionGroups.map(() => null); // 디폴트: 첫 번째 옵션

    // 렌더링
    function renderGroups() {
      sizeBtns.innerHTML = optionGroups
        .map((group, groupIdx) => {
          const optionName = product.options ? product.options[groupIdx] : `Option ${groupIdx + 1}`;
          const sizeGuideHtml = optionName.toLowerCase() === 'size' ? `<div class="byl-size-guide size-guide">SIZE GUIDE</div>` : '';
          return `
            <div class="byl-option-group" data-group-index="${groupIdx}" data-option-group="${optionName}">
              <div class="byl-size-header">
                <span class="byl-size-label">${selectedOptions[groupIdx] ? `${optionName}: ${selectedOptions[groupIdx]}` : `Select ${optionName}`}</span>
                ${sizeGuideHtml}
              </div>
              <div class="byl-option-values">
                ${group.values.map((val) => {
                  // 이 옵션값 선택 시 available variant 존재 여부 체크
                  const testOptions = [...selectedOptions];
                  testOptions[groupIdx] = val;
                  const available = variants.some((v) =>
                    testOptions.every((opt, idx) => opt === null || v[`option${idx + 1}`] === opt) && v.available
                  );
                  const isActive = selectedOptions[groupIdx] === val;
                  return `<button
                    class="byl-size-btn${isActive ? ' is-active' : ''}${available ? '' : ' is-unavailable'}"
                    data-group-index="${groupIdx}"
                    data-value='${val}'
                    data-step="${step}"
                    ${available ? '' : 'disabled'}
                  >${val}</button>`;
                }).join('')}
              </div>
            </div>
          `;
        })
        .join('');

        // 버튼 이벤트 재등록
        sizeBtns.querySelectorAll('.byl-size-btn:not(.is-unavailable)').forEach((btn) => {
          btn.addEventListener('click', function () {
            const groupIdx = parseInt(this.dataset.groupIndex);
            const value = this.dataset.value;
            const s = parseInt(this.dataset.step);

            selectedOptions[groupIdx] = value;
            state[s].selectedOptions[groupIdx] = value;

            // variant 매칭
            const allSelected = selectedOptions.every(opt => opt !== null);

            if (allSelected) {
              const variant = variants.find((v) =>
                selectedOptions.every((opt, idx) => v[`option${idx + 1}`] === opt)
              );
              state[s].variantId = variant ? variant.id : null;
            } else {
              state[s].variantId = null;
            }
            state[s].size = selectedOptions.filter(Boolean).join(' / ');

            // 다시 렌더링 (품절 상태 업데이트)
            renderGroups();
            updateYourSet();
            updateATC();

            // ★ 첫 진입 후 1회 자동 모달 열림 (MO에서만)
            if (!modalAutoOpened && window.innerWidth < 768) {
              const allSelected = selectedOptions.every(opt => opt !== null);
              if (allSelected) {
                modalAutoOpened = true;
                openMoModal();
              }
            }
          });
        });

      }

      renderGroups();
      sizeArea.style.display = 'block';
      sizeLabel.textContent = ''; // 개별 옵션 라벨로 대체되므로 숨김

      // 디폴트 첫 번째 옵션으로 variant 자동 선택
      /*
      const defaultVariant = variants.find((v) =>
        selectedOptions.every((opt, idx) => v[`option${idx + 1}`] === opt)
      );
      if (defaultVariant) {
        state[step].variantId = defaultVariant.id;
        state[step].size = selectedOptions.join(' / ');
      }
      */

      updateYourSet();
      updateATC();
    }


    function getSizeOptionIndex(variants) {
      // variant option 키 중 'size' 포함 여부로 판단 (기본 0)
      if (!variants.length) return 0;
      const v = variants[0];
      // Shopify variant에는 option_values 배열이 없으므로 index 0 사용
      return 0;
    }

    // ── 왼쪽 PREV/NEXT 버튼 ─────────────────────────────────────
    document.querySelectorAll('.byl-thumb-prev').forEach((btn) => {
      btn.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        const current = state[step].productIndex;
        const newIndex = Math.max(0, current - 1);
        selectProduct(step, newIndex);
        updateNavDeactive(step, newIndex, document.querySelector('.byl-left'));
      });
    });

    document.querySelectorAll('.byl-thumb-next').forEach((btn) => {
      btn.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        const current = state[step].productIndex;
        const max = allProducts[step].length - 1;
        const newIndex = Math.min(max, current + 1);
        selectProduct(step, newIndex);
        updateNavDeactive(step, newIndex, document.querySelector('.byl-left'));
      });
    });

    // ── 왼쪽 썸네일 슬라이드 클릭 ───────────────────────────────
    document.querySelectorAll('.byl-thumb-slide').forEach((slide) => {
      slide.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        const index = parseInt(this.dataset.index);
        selectProduct(step, index);
      });
    });

    // ── 상품 Detail 업데이트 ─────────────────────────────────────
  
    function updateProductDetail(product) {
    const detailEl = document.getElementById('byl-product-detail');
    const descEl = document.getElementById('byl-product-desc');
    const titleEl = document.getElementById('byl-product-desc-title');
    const detailLink = document.querySelector('.byl-product-detail-page');

    // fade out
    detailEl.style.transition = 'opacity 0.15s ease';
    detailEl.style.opacity = '0.3';

    setTimeout(() => {
      const images = (product.images || []).filter(Boolean);
      if (images.length) initDetailSwiper(images);

      titleEl.textContent = product.title || '';
      descEl.innerHTML = product.description || '';

      if (detailLink) {
        const url = product.base_product_page || '';
        detailLink.href = url;
        detailLink.style.display = url ? 'inline-block' : 'none';
      }

      detailEl.style.display = 'block';

      // fade in
      requestAnimationFrame(() => {
        detailEl.style.opacity = '1';
      });
    }, 150);
  }

  // ── 다중 옵션 단계적 텍스트 렌더링 함수 ───────────────────────
  function getProgressiveSizeHtml(step, isModal) {
    const s = state[step];
    if (!s.product || !s.product.options) return '';

    const completedClass = isModal ? 'byl-mo-modal__slot-size' : 'byl-set-slot-size';
    
    const options = s.product.options;
    const selectedArr = s.selectedOptions || [];
    
    const selectedParts = [];
    const unselectedParts = [];

    // 1. 선택된 옵션과 미선택 옵션을 분리
    options.forEach((optName, idx) => {
      const val = selectedArr[idx];
      if (val) {
        selectedParts.push(`${optName}: ${val}`);
      } else {
        unselectedParts.push(optName.toLowerCase());
      }
    });

    const allSelected = unselectedParts.length === 0;
    const noneSelected = selectedParts.length === 0;

    // [상태 1] 모든 옵션이 선택된 경우 (예: Inseam: 23" / Size: S)
    if (allSelected) {
      return `<span class="${completedClass}">${selectedParts.join(' / ')}</span>`;
    } 
    
    // [상태 2] 아무것도 선택되지 않은 경우 (예: Select inseam and size)
    if (noneSelected) {
      return `<button class="byl-mo-modal__select-size" data-step="${step}">Select ${unselectedParts.join(' and ')}</button>`;
    }

    // [상태 3] 일부만 선택된 경우 (예: Size: S 줄바꿈 후 Select inseam)
    // 텍스트에 display: block을 주어 자연스럽게 줄바꿈이 일어나도록 처리합니다.
    const btnText = unselectedParts.length === 1 
      ? `Select ${unselectedParts[0]}` 
      : `Select ${unselectedParts.join(' and ')}`;
    
    return `
      <span class="${completedClass}" style="display: block; margin-bottom: 2px;">${selectedParts.join(' / ')}</span>
      <button class="byl-mo-modal__select-size" data-step="${step}">${btnText}</button>
    `;
  }
  // ── 상품별 가격 HTML (variant 가격이 아니라 product.price / product.compare_at_price 사용) ──
  function getPriceHtml(product, wrapperClass) {
    if (!product || typeof product.price !== 'number') return '';

    const hasCompare = product.compare_at_price && product.compare_at_price > product.price;
    const inner = hasCompare
      ? `<span class="price price--highlight">${formatMoney(product.price)}</span><span class="price price--compare">${formatMoney(product.compare_at_price)}</span>`
      : `<span class="price">${formatMoney(product.price)}</span>`;

    return `<div class="${wrapperClass} price-list">${inner}</div>`;
  }

  // ── Your Set 업데이트 ────────────────────────────────────────
  function updateYourSet() {
    [1, 2].forEach((step) => {
      const s = state[step];
      const slot = document.getElementById(`byl-slot-${step}`);

      if (s.product) {
        const nameParts = s.product.title.split(' - ');
        const name = nameParts[0] || s.product.title;
        const color = nameParts[1] || '';
        const displayName = color ? `${name} - ${color}` : name;

        slot.innerHTML = `
          <div class="byl-set-slot-img">
            ${s.product.thumbnail
              ? `<img src="${s.product.thumbnail}" alt="${s.product.title}">`
              : '<div class="byl-placeholder"></div>'
            }
          </div>
          <div class="byl-set-slot-info">
            <span class="byl-set-slot-category">${step === 1 ? 'Top' : 'Bottom'}</span>
            <span class="byl-set-slot-name">${displayName}</span>
            ${getProgressiveSizeHtml(step, false)} </div>
        `;
        // ${getPriceHtml(s.product, 'byl-set-slot-price')}
        
      } else {
        slot.innerHTML = `
          <div class="byl-set-slot-img byl-placeholder"></div>
          <div class="byl-set-slot-info">
            <span class="byl-set-slot-empty">${step === 1 ? 'Top을 선택해주세요' : 'Bottom을 선택해주세요'}</span>
          </div>
        `;
      }
    });

    // ★ YOUR SET 슬롯 내 Select size 버튼 이벤트
    document.querySelectorAll('.byl-set-slot-info .byl-mo-modal__select-size').forEach((btn) => {
      btn.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        switchTab(step);
        const panel = document.querySelector(`.byl-tab-panel[data-panel="${step}"]`);
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    updateYourSetFooter();
  }

  // // ── Your Set 합계(Total): 현재가 합계 + 번들 할인율 적용 ──
  // function getYourSetTotals() {
  //   const p1 = state[1].product;
  //   const p2 = state[2].product;

  //   if (!p1 || !p2 || typeof p1.price !== 'number' || typeof p2.price !== 'number') {
  //     return null;
  //   }

  //   // 현재가(price) 합계
  //   const priceSum = p1.price + p2.price;

  //   // 할인율이 있으면: compare = 현재가 합계, price = 할인가
  //   if (bundleDiscountPercent > 0) {
  //     const discountedTotal = Math.round(priceSum * (1 - bundleDiscountPercent / 100));
  //     return { priceTotal: discountedTotal, compareTotal: priceSum };
  //   }

  //   // 할인율이 0이면: 기존 로직 (compare_at_price 기반)
  //   const compareFor = (p) =>
  //     typeof p.compare_at_price === 'number' && p.compare_at_price > p.price
  //       ? p.compare_at_price
  //       : p.price;

  //   const compareTotal = compareFor(p1) + compareFor(p2);
  //   return { priceTotal: priceSum, compareTotal };
  // }

  // ── Your Set 합계(Total) ──
  //   compareTotal(.price--compare)   = 각 상품 원가(compare_at_price) 합계
  //   priceTotal  (.price--highlight) = 각 상품 판매가(price) 합계에서 번들 할인율 적용
  function getYourSetTotals() {
    const p1 = state[1].product;
    const p2 = state[2].product;

    if (!p1 || !p2 || typeof p1.price !== 'number' || typeof p2.price !== 'number') {
      return null;
    }

    // 원가: compare_at_price가 없거나 판매가보다 낮으면 판매가로 대체
    const originalFor = (p) =>
      typeof p.compare_at_price === 'number' && p.compare_at_price > p.price
        ? p.compare_at_price
        : p.price;

    const compareTotal = originalFor(p1) + originalFor(p2);

    // 판매가 합계 → 번들 할인율 적용
    const priceSum = p1.price + p2.price;
    const priceTotal = bundleDiscountPercent > 0
      ? Math.round(priceSum * (1 - bundleDiscountPercent / 100))
      : priceSum;

    return { priceTotal, compareTotal };
  }

  function renderYourSetFooter(footerEl, labelClass) {
    if (!footerEl) return;

    const totals = getYourSetTotals();
    if (!totals) {
      footerEl.style.display = 'none';
      footerEl.innerHTML = '';
      return;
    }

    const hasDiscount = totals.compareTotal > totals.priceTotal;
    const priceHtml = hasDiscount
      ? `<span class="price price--highlight">${formatMoney(totals.priceTotal)}</span><span class="price price--compare">${formatMoney(totals.compareTotal)}</span>`
      : `<span class="price">${formatMoney(totals.priceTotal)}</span>`;

    footerEl.innerHTML = `
      <span class="${labelClass}">Total</span>
      <span class="price-list">${priceHtml}</span>
    `;
    footerEl.style.display = 'flex';
  }

  function updateYourSetFooter() {
    renderYourSetFooter(document.getElementById('byl-your-set-footer'), 'byl-your-set-footer-label');
  }

  // ── ATC 버튼 상태 ────────────────────────────────────────────
  function updateATC() {
    const btn = document.getElementById('byl-add-to-cart');
    const bothReady = state[1].variantId && state[2].variantId;
    btn.disabled = !bothReady;
  }

  // ── MO 전용 썸네일 슬라이더 복제 ────────────────────────────
  function initMobileThumbSlider() {
    const originalLeft = document.querySelector('.byl-left');
    const yourSet = document.getElementById('byl-your-set');
    if (!originalLeft || !yourSet) return;

    const mobileThumb = originalLeft.cloneNode(true);
    mobileThumb.classList.add('byl-left-mobile');
    mobileThumb.removeAttribute('id');

    yourSet.parentNode.insertBefore(mobileThumb, yourSet);

    const mobileSwiperTop = new Swiper(mobileThumb.querySelector('.byl-swiper-top'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      // ★ 스와이프로 슬라이드 변경 시 상품 업데이트
      on: {
        slideChange: function () {
          const index = this.activeIndex;
          selectProduct(1, index);
          // ★ 스와이프 시 deactive 업데이트
          updateNavDeactive(1, index, mobileThumb);
        },
      },
    });

    const mobileSwiperBottom = new Swiper(mobileThumb.querySelector('.byl-swiper-bottom'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      // ★ 스와이프로 슬라이드 변경 시 상품 업데이트
      on: {
        slideChange: function () {
          const index = this.activeIndex;
          selectProduct(2, index);
          // ★ 스와이프 시 deactive 업데이트
          updateNavDeactive(2, index, mobileThumb);
        },
      },
    });

    // 복제된 슬라이드 클릭 이벤트
    mobileThumb.querySelectorAll('.byl-thumb-slide').forEach((slide) => {
      slide.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        const index = parseInt(this.dataset.index);
        selectProduct(step, index);
      });
    });

    // ★ PREV/NEXT 버튼 + deactive 클래스 처리
    mobileThumb.querySelectorAll('.byl-thumb-prev').forEach((btn) => {
      btn.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        const current = state[step].productIndex;
        const newIndex = Math.max(0, current - 1);
        selectProduct(step, newIndex);
        updateNavDeactive(step, newIndex, mobileThumb);
      });
    });

    mobileThumb.querySelectorAll('.byl-thumb-next').forEach((btn) => {
      btn.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        const current = state[step].productIndex;
        const max = allProducts[step].length - 1;
        const newIndex = Math.min(max, current + 1);
        selectProduct(step, newIndex);
        updateNavDeactive(step, newIndex, mobileThumb);
      });
    });

    window._mobileSwiperTop = mobileSwiperTop;
    window._mobileSwiperBottom = mobileSwiperBottom;
    window._mobileThumb = mobileThumb;

    // 초기 deactive 상태 설정
    updateNavDeactive(1, state[1].productIndex, mobileThumb);
    updateNavDeactive(2, state[2].productIndex, mobileThumb);
  }

  // ★ PREV/NEXT deactive 클래스 관리
  function updateNavDeactive(step, index, container) {
    const max = allProducts[step].length - 1;
    const target = container || document;

    const prevBtn = target.querySelector(`.byl-thumb-prev[data-step="${step}"]`);
    const nextBtn = target.querySelector(`.byl-thumb-next[data-step="${step}"]`);

    if (prevBtn) prevBtn.classList.toggle('deactive', index <= 0);
    if (nextBtn) nextBtn.classList.toggle('deactive', index >= max);
  }

  initMobileThumbSlider();

  // ── MO 모달 ──────────────────────────────────────────────────
  let modalAutoOpened = false; // 첫 진입 1회 자동 열림 플래그

  function openMoModal() {
    renderMoModalSlots();
    document.getElementById('byl-mo-modal').classList.add('is-open');
    document.getElementById('byl-mo-arrow').classList.add('hide');
    document.body.style.overflow = 'hidden';
  }

  function closeMoModal() {
    document.getElementById('byl-mo-modal').classList.remove('is-open');
    document.getElementById('byl-mo-arrow').classList.remove('hide');
    document.body.style.overflow = '';
  }

  function renderMoModalSlots() {
    const slotsEl = document.getElementById('byl-mo-modal-slots');
    slotsEl.innerHTML = [1, 2].map((step) => {
      const s = state[step];
      const label = step === 1 ? 'Top' : 'Bottom';

      if (!s.product) {
        return `
          <div class="byl-mo-modal__slot">
            <div class="byl-mo-modal__slot-img byl-placeholder"></div>
            <div class="byl-mo-modal__slot-info">
              <span class="byl-mo-modal__slot-category">${label}</span>
              <span class="byl-mo-modal__slot-empty">상품을 선택해주세요</span>
            </div>
          </div>
        `;
      }

      const nameParts = s.product.title.split(' - ');
      const name = nameParts[0] || s.product.title;
      const color = nameParts[1] || '';
      const displayName = color ? `${name} - ${color}` : name;
      const hasSize = !!s.variantId;

      return `
          <div class="byl-mo-modal__slot">
            <div class="byl-mo-modal__slot-img">
              ${s.product.thumbnail
                ? `<img src="${s.product.thumbnail}" alt="${s.product.title}">`
                : '<div class="byl-placeholder"></div>'
              }
            </div>
            <div class="byl-mo-modal__slot-info">
              <span class="byl-mo-modal__slot-category">${label}</span>
              <span class="byl-mo-modal__slot-name">${displayName}</span>
              ${getProgressiveSizeHtml(step, true)} </div>
          </div>
        `;
              // ${getPriceHtml(s.product, 'byl-mo-modal__slot-price')}
      }).join('<div class="byl-diviver mo-only"></div>');

    // Select size 클릭 → 모달 닫고 해당 탭으로 이동
    slotsEl.querySelectorAll('.byl-mo-modal__select-size').forEach((btn) => {
      btn.addEventListener('click', function () {
        const step = parseInt(this.dataset.step);
        closeMoModal();
        switchTab(step);
        // 해당 탭 영역으로 스크롤
        const panel = document.querySelector(`.byl-tab-panel[data-panel="${step}"]`);
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    renderYourSetFooter(document.getElementById('byl-mo-modal-footer'), 'byl-mo-modal__footer-label');
  }

  // 화살표 클릭
  document.getElementById('byl-mo-arrow')?.addEventListener('click', openMoModal);

  // 닫기 버튼
  document.getElementById('byl-mo-modal-close')?.addEventListener('click', closeMoModal);

  // 바깥 클릭
  document.getElementById('byl-mo-modal-backdrop')?.addEventListener('click', closeMoModal);

  // ── Add to Cart ──────────────────────────────────────────────
  document.getElementById('byl-add-to-cart')?.addEventListener('click', async function () {
    const btn = this;
    const btnText = btn.querySelector('.byl-atc-text');
    const btnLoading = btn.querySelector('.byl-atc-loading');
    const moBtnText = moAtcBtn?.querySelector('.byl-atc-text');
    const moBtnLoading = moAtcBtn?.querySelector('.byl-atc-loading');

    btn.disabled = true;
    if (moAtcBtn) moAtcBtn.disabled = true;

    // ★ display 대신 클래스로 제어
    btnText.classList.add('is-hidden');
    btnLoading.classList.add('is-active');
    if (moBtnText) moBtnText.classList.add('is-hidden');
    if (moBtnLoading) moBtnLoading.classList.add('is-active');

    try {
      // ★ 세트 페이지 URL과 서로의 variant id를 hidden property로 남겨서,
      //   장바구니에서 클릭 시 단품이 아니라 이 세트페이지로, 선택 상태 그대로 돌아올 수 있게 함
      const bundlePageUrl = window.location.pathname;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: state[1].variantId,
              quantity: 1,
              properties: {
                _bundle_page: bundlePageUrl,
                _bundle_step: '1',
                _bundle_partner_variant_id: String(state[2].variantId),
                _bundle_id: bundlePageUrl + '_' + Date.now(),
              },
            },
            {
              id: state[2].variantId,
              quantity: 1,
              properties: {
                _bundle_page: bundlePageUrl,
                _bundle_step: '2',
                _bundle_partner_variant_id: String(state[1].variantId),
                _bundle_id: bundlePageUrl + '_' + Date.now(),
              },
            },
          ],
        }),
      });

      if (!res.ok) {
        let message = '장바구니 추가 중 오류가 발생했습니다. 다시 시도해주세요.';
        try {
          const errorData = await res.json();
          message = errorData?.message || errorData?.description || message;
        } catch (parseErr) {
          // 응답이 JSON이 아닌 경우 기본 메시지 사용
        }
        throw new Error(message);
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const cartLink = document.querySelector('.header__icon--cart .header__link');
      const addBundleAlert = document.querySelector('.add-bundle-toast__box');

      if (cartLink) cartLink.textContent = `Bag (${cart.item_count})`;

      if (addBundleAlert) {
        addBundleAlert.classList.add('on');
        setTimeout(() => addBundleAlert.classList.remove('on'), 3000);
      }

    } catch (err) {
      console.error(err);
      alert(err.message || '장바구니 추가 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      btn.disabled = false;
      if (moAtcBtn) moAtcBtn.disabled = false;

      // ★ 클래스 제거
      btnText.classList.remove('is-hidden');
      btnLoading.classList.remove('is-active');
      if (moBtnText) moBtnText.classList.remove('is-hidden');
      if (moBtnLoading) moBtnLoading.classList.remove('is-active');
    }
  });



  // ── Clear All ────────────────────────────────────────────────
  document.getElementById('byl-clear-all')?.addEventListener('click', function () {
    state[1] = { productIndex: 0, product: null, variantId: null, size: '', selectedOptions: [] };
    state[2] = { productIndex: 0, product: null, variantId: null, size: '', selectedOptions: [] };

    document.querySelectorAll('.byl-grid-item').forEach((el) => el.classList.remove('is-active'));
    document.querySelectorAll('.byl-thumb-slide').forEach((el) => el.classList.remove('is-active'));
    document.getElementById('byl-size-1').style.display = 'none';
    document.getElementById('byl-size-2').style.display = 'none';
    document.getElementById('byl-product-detail').style.display = 'none';
    // document.getElementById('byl-success').style.display = 'none';

    updateYourSet();
    updateATC();
  });

  // ── MO 전용 ATC 버튼 연동 ────────────────────────────────────
  const moAtcBtn = document.querySelector('.byl-mo-atc-btn .byl-atc-btn');
  const realAtcBtn = document.getElementById('byl-add-to-cart');

  if (moAtcBtn && realAtcBtn) {
    // 진짜 버튼 상태 변화 감지 → 가짜 버튼에 동기화
    // const observer = new MutationObserver(() => {
    //   moAtcBtn.disabled = realAtcBtn.disabled;
    // });
    // observer.observe(realAtcBtn, { attributes: true, attributeFilter: ['disabled'] });

    // 초기 상태 동기화
    moAtcBtn.disabled = false;

    // 가짜 버튼 클릭 → 진짜 버튼 클릭 트리거
    moAtcBtn.addEventListener('click', function () {
      const allReady = state[1].variantId && state[2].variantId;
      if (!allReady) {
        openMoModal();
      } else {
        realAtcBtn.click();
      }
    });
  }


  // ── 장바구니에서 돌아왔을 때 이전 선택(상품+옵션) 복원  ──────────
  // 장바구니 라인아이템 링크가 ?top_variant=...&bottom_variant=... 형태로
  // 이 페이지에 돌아오면, 해당 variant를 가진 상품을 찾아 옵션까지 자동 선택
  function getQueryParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function findProductIndexByVariantId(step, variantId) {
    const products = allProducts[step] || [];
    return products.findIndex((product) =>
      (product.variants || []).some((v) => String(v.id) === String(variantId))
    );
  }

  function selectVariantOptions(step, product, variant) {
    const optionValues = [variant.option1, variant.option2, variant.option3].filter(Boolean);

    optionValues.forEach((value, groupIdx) => {
      const btn = document.querySelector(
        `#byl-size-btns-${step} .byl-size-btn[data-group-index="${groupIdx}"][data-value="${CSS.escape(value)}"]`
      );
      if (btn && !btn.disabled) btn.click();
    });
  }

  // ── 초기 상태: 장바구니에서 온 variant가 있으면 복원, 없으면 첫 번째 상품 자동 선택 ──
  const hasRestoreParams = getQueryParam('top_variant') || getQueryParam('bottom_variant');
  if (hasRestoreParams) modalAutoOpened = true;  // 복원 중 자동 오픈 차단

  [1, 2].forEach((step) => {
    if (!allProducts[step].length) return;

    const variantId = getQueryParam(step === 1 ? 'top_variant' : 'bottom_variant');
    const index = variantId ? findProductIndexByVariantId(step, variantId) : -1;

    if (index === -1) {
      selectProduct(step, 0);
      return;
    }

    const product = allProducts[step][index];
    const variant = product.variants.find((v) => String(v.id) === String(variantId));

    selectProduct(step, index);
    if (variant) selectVariantOptions(step, product, variant);
  });

  if (hasRestoreParams && window.innerWidth < 768 && state[1].variantId && state[2].variantId) {
    renderMoModalSlots();   // 최신 state로 먼저 그리고
    openMoModal();
  }

  switchTab(1);

  // ★ 첫 로드 시 PC/MO 모두 deactive 초기 상태 설정
  // (initMobileThumbSlider 이후에 실행되어야 하므로 여기서 한 번 더 호출)
  setTimeout(() => {
    updateNavDeactive(1, 0, document.querySelector('.byl-left'));
    updateNavDeactive(2, 0, document.querySelector('.byl-left'));
    if (window._mobileThumb) {
      updateNavDeactive(1, 0, window._mobileThumb);
      updateNavDeactive(2, 0, window._mobileThumb);
    }
  }, 0);

  window.addEventListener('scroll', () => {
    const target = document.querySelector('#byl-add-to-cart');
    const button = document.querySelector('.byl-mo-atc-btn');
    const moArrow = document.querySelector('#byl-mo-arrow');

    if (!target || !button) return;

    const rect = target.getBoundingClientRect();

    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      button.classList.add('hide');
      moArrow.classList.add('hide');
    } else {
      button.classList.remove('hide');
      moArrow.classList.remove('hide');
    }
  });

  // ── PC 전용 Tolstoy 캐러셀 드래그 스크롤 ────────────────────────
  (function () {
    const isDesktopMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isDesktopMouse) return;

    function setupTrack(track) {
      if (!track || track.dataset.dragInitialized) return;
      track.dataset.dragInitialized = 'true';
      track.style.cursor = 'grab';

      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let isDragging = false;

      let velocity = 0;
      let lastX = 0;
      let lastTime = 0;
      let animationId = null;

      function runInertia() {
        if (Math.abs(velocity) < 0.1) {
          cancelAnimationFrame(animationId);
          animationId = null;
          return;
        }
        track.scrollLeft -= velocity;
        velocity *= 0.95;
        animationId = requestAnimationFrame(runInertia);
      }

      track.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        isDown = true;
        isDragging = false;

        if (animationId) {
          cancelAnimationFrame(animationId);
          animationId = null;
        }
        velocity = 0;

        track.style.cursor = 'grabbing';
        track.style.userSelect = 'none';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
      });

      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        track.style.cursor = 'grab';
        track.style.removeProperty('user-select');

        if (isDragging) {
          runInertia();
        }
        setTimeout(() => { isDragging = false; }, 50);
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.5;

        if (Math.abs(walk) > 5) {
          isDragging = true;
        }

        track.scrollLeft = scrollLeft - walk;

        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) {
          const deltaX = e.pageX - lastX;
          velocity = (deltaX / dt) * 16.6;
        }
        lastX = e.pageX;
        lastTime = now;
      });

      track.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    function initDragScroll() {
      const tracks = document.querySelectorAll('.carousel-track');
      tracks.forEach(setupTrack);
    }

    const observer = new MutationObserver(() => {
      initDragScroll();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    initDragScroll();
  })();
});
